
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../Components/Footer/Footer';
import Header from '../../../Components/Header/Header';
import '../../../assets/css/Checkout.css'
import StripeForm from '../../../Components/Stripe/StripeForm'
import { useDispatch, useSelector } from 'react-redux';
import { UpgradeSubscriptionApi } from '../../../Redux/Auth/Auth_Action';
import { toast } from 'react-toastify';
import { showLoader } from '../../../Redux/services/Loader';

const Checkout = () => {

    let navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const reduxStateToken = useSelector((state) => state.Auth.token);

    const SubmitData = () => {
        let data = {
            slug: location?.state?.NewData?.slug,
            payment_type: location?.state?.NewData?.paymentType,
            interest: location?.state?.NewData?.interest,
        }

        dispatch(UpgradeSubscriptionApi(data, reduxStateToken))
            .then((res) => {
                showLoader("none");
                if (res.data.message === "Package has been upgrade successfully!") {
                    toast.info("Package has been upgrade successfully!");
                    // setOpenModal2(true)
                    navigate('/Thankyou');
                } else {
                    toast.info(res.data.message);
                }
                // console.log("res", res);
            }).catch((e) => {
                console.log("errror from checkout page ", e);
                showLoader("none");
            })
    }

    useEffect(() => {
        window.scroll(0, 0);
    }, [])

    return (
        <div className='checkout'>
            <section className='checkout-container'>
                <Header />
                <h2 className='title mb-4'>Order Checkout</h2>
                <div className='container pb-5'>
                    <div className='row'>
                        <div className='col-md-8'>
                            <div className='left-side h-100'>
                                <h2 className='sub-title'>Proceed to pay </h2>
                                <div className='row'>
                                    {/* <div className='col-md-6 mt-3'>
                                       <input type="text" placeholder='First Name' />
                                   </div>
                                   <div className='col-md-6 mt-3'>
                                       <input type="text" placeholder='Last Name' />
                                   </div>
                                   <div className='col-md-6 mt-3'>
                                       <input type="text" placeholder='Email' />
                                   </div>
                                   <div className='col-md-6 mt-3'>
                                       <input type="text" placeholder='Phone' />
                                   </div> */}
                                    <div className='col-md-12 mt-5'>
                                        <button onClick={SubmitData} className='btn btn-light btn-pink-now f-mon-reg'>Confirm Payment</button>
                                        {/* <StripeForm /> */}
                                        {/* <div>
                                            <button className='btn proceedBtn'>Proceed To Pay</button>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='right-side'>
                                <h2 className='order-title '>Order Details</h2>
                                <div className='membership-container'>
                                    <p className='membership'>{location?.state?.NewData?.slug} </p>
                                    <p className='membership'>{location?.state?.NewData?.price}</p>
                                </div>
                                <hr className='hr-line' />
                                <div className='membership-container'>
                                    <p className='membership'>Grand Total</p>
                                    <p className='membership'>{location?.state?.NewData?.price}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Checkout;
